// extracted by mini-css-extract-plugin
export default {"settings-toggle":"SettingsToggle_settings-toggle__-5L7W"};